import { ctaClick } from '@wix/bi-logger-any-marketing-lp/v2';
import { BI_Events } from '../../constants/biEvents';
import { factory } from '@wix/web-bi-logger';

type Logger = ReturnType<ReturnType<typeof factory>['logger']>;

interface errorPageDataType {
  title: string;
  description: string;
  buttonLabel: string;
  buttonLink: string;
  hideCTA?: boolean;
  nonBranded?: boolean;
}

export const reportError = ({
  biLogger,
  biEventsErrorKey,
}: {
  biLogger: Logger;
  biEventsErrorKey: BI_Events_Error_Key;
}) => {
  biLogger
    .report(
      ctaClick({
        ...BI_Events[biEventsErrorKey],
        pageUrl: window.location.href,
        targetUrl: errorMapping[biEventsErrorKey].buttonLink,
      }),
    )
    .catch((e: Error) => console.log(e));
};

const baseURL = window.location.origin;

export const errorMapping: { [key: string]: errorPageDataType } = {
  '400': {
    title: 'classic.error.400.title',
    description: 'classic.error.400.description',
    buttonLabel: '',
    buttonLink: '',
    hideCTA: true,
  },
  '400-NotBranded': {
    title: 'classic.error.400.title',
    description: 'classic.error.400.description',
    buttonLabel: '',
    buttonLink: '',
    hideCTA: true,
  },
  '400-Base44': {
    title: 'classic.error.title.base44',
    description: 'classic.error.400.description',
    buttonLabel: 'classic.error.button.label.base44',
    buttonLink: 'classic.error.button.link.base44',
  },
  '401': {
    title: 'classic.error.401.title',
    description: 'classic.error.401.description',
    buttonLabel: 'classic.error.401.button.label',
    buttonLink: 'classic.error.401.button.link',
  },
  '401-NotBranded': {
    title: 'classic.error.401.title',
    description: 'classic.error.401.description',
    buttonLabel: 'classic.error.401.button.label.not-branded',
    buttonLink: baseURL,
  },
  '401-Wixel': {
    title: 'classic.error.401.title',
    description: 'classic.error.401.description',
    buttonLabel: 'classic.error.401.button.label.wixel',
    buttonLink: 'classic.error.401.button.link.wixel',
  },
  '401-Base44': {
    title: 'classic.error.title.base44',
    description: 'classic.error.401.description',
    buttonLabel: 'classic.error.button.label.base44',
    buttonLink: 'classic.error.button.link.base44',
  },
  '403': {
    title: 'classic.error.403.title',
    description: 'classic.error.403.description',
    buttonLabel: 'classic.error.403.button.label',
    buttonLink: 'classic.error.403.button.link',
  },
  '403-NotBranded': {
    title: 'classic.error.403.title',
    description: 'classic.error.403.description',
    buttonLabel: 'classic.error.403.button.label.not-branded',
    buttonLink: baseURL,
  },
  '403-Wixel': {
    title: 'classic.error.403.title',
    description: 'classic.error.403.description',
    buttonLabel: 'classic.error.403.button.label.wixel',
    buttonLink: 'classic.error.403.button.link.wixel',
  },
  '403-Base44': {
    title: 'classic.error.title.base44',
    description: 'classic.error.403.description',
    buttonLabel: 'classic.error.button.label.base44',
    buttonLink: 'classic.error.button.link.base44',
  },
  '404': {
    title: 'classic.error.404.title',
    description: 'classic.error.404.description',
    buttonLabel: 'classic.error.404.button.label',
    buttonLink: 'classic.error.404.button.link',
  },
  '404-NotBranded': {
    title: 'classic.error.404.title',
    description: 'classic.error.404.description',
    buttonLabel: 'classic.error.404.button.label.not-branded',
    buttonLink: baseURL,
  },
  '404-Wixel': {
    title: 'classic.error.404.title',
    description: 'classic.error.404.description',
    buttonLabel: 'classic.error.404.button.label.wixel',
    buttonLink: 'classic.error.404.button.link.wixel',
  },
  '404-Base44': {
    title: 'classic.error.title.base44',
    description: 'classic.error.404.description.base44',
    buttonLabel: 'classic.error.button.label.base44',
    buttonLink: 'classic.error.button.link.base44',
  },
  '410': {
    title: 'classic.error.410.title',
    description: 'classic.error.410.description',
    buttonLabel: 'classic.error.410.button.label',
    buttonLink: 'classic.error.410.button.link',
  },
  '410-NotBranded': {
    title: 'classic.error.410.title',
    description: 'classic.error.410.description',
    buttonLabel: 'classic.error.410.button.label.not-branded',
    buttonLink: baseURL,
  },
  '410-Wixel': {
    title: 'classic.error.410.title',
    description: 'classic.error.410.description',
    buttonLabel: 'classic.error.410.button.label.wixel',
    buttonLink: 'classic.error.410.button.link.wixel',
  },
  '410-Base44': {
    title: 'classic.error.title.base44',
    description: 'classic.error.410.description',
    buttonLabel: 'classic.error.button.label.base44',
    buttonLink: 'classic.error.button.link.base44',
  },
  '429': {
    title: 'classic.error.429.title',
    description: 'classic.error.429.description',
    buttonLabel: 'classic.error.429.button.label',
    buttonLink: 'classic.error.429.button.link',
  },
  '429-NotBranded': {
    title: 'classic.error.429.title',
    description: 'classic.error.429.description',
    buttonLabel: 'classic.error.429.button.label.not-branded',
    buttonLink: baseURL,
  },
  '429-Wixel': {
    title: 'classic.error.429.title',
    description: 'classic.error.429.description',
    buttonLabel: 'classic.error.429.button.label.wixel',
    buttonLink: 'classic.error.429.button.link.wixel',
  },
  '429-Base44': {
    title: 'classic.error.title.base44',
    description: 'classic.error.429.description',
    buttonLabel: 'classic.error.button.label.base44',
    buttonLink: 'classic.error.button.link.base44',
  },
  '500': {
    title: 'classic.error.500.title',
    description: 'classic.error.500.description',
    buttonLabel: 'classic.error.500.button.label',
    buttonLink: 'classic.error.500.button.link',
  },
  '500-NotBranded': {
    title: 'classic.error.500.title',
    hideCTA: true,
    description: 'classic.error.500.description',
    buttonLabel: '',
    buttonLink: '',
  },
  '500-Base44': {
    title: 'classic.error.title.base44',
    description: 'classic.error.500.description',
    buttonLabel: 'classic.error.button.label.base44',
    buttonLink: 'classic.error.button.link.base44',
  },
  '502': {
    title: 'classic.error.502.title',
    description: 'classic.error.502.description',
    buttonLabel: 'classic.error.502.button.label',
    buttonLink: 'classic.error.502.button.link',
  },
  '502-NotBranded': {
    title: 'classic.error.502.title',
    hideCTA: true,
    description: 'classic.error.502.description',
    buttonLabel: '',
    buttonLink: '',
  },
  '502-Base44': {
    title: 'classic.error.title.base44',
    description: 'classic.error.502.description',
    buttonLabel: 'classic.error.button.label.base44',
    buttonLink: 'classic.error.button.link.base44',
  },
  '503': {
    title: 'classic.error.503.title',
    description: 'classic.error.503.description',
    buttonLabel: 'classic.error.503.button.label',
    buttonLink: 'classic.error.503.button.link',
  },
  '503-NotBranded': {
    title: 'classic.error.503.title',
    hideCTA: true,
    description: 'classic.error.503.description',
    buttonLabel: '',
    buttonLink: '',
  },
  '503-Base44': {
    title: 'classic.error.title.base44',
    description: 'classic.error.503.description',
    buttonLabel: 'classic.error.button.label.base44',
    buttonLink: 'classic.error.button.link.base44',
  },
  '504': {
    title: 'classic.error.504.title',
    description: 'classic.error.504.description',
    buttonLabel: 'classic.error.504.button.label',
    buttonLink: 'classic.error.504.button.link',
  },
  '504-NotBranded': {
    title: 'classic.error.504.title',
    hideCTA: true,
    description: 'classic.error.504.description',
    buttonLabel: '',
    buttonLink: '',
  },
  '504-Base44': {
    title: 'classic.error.title.base44',
    description: 'classic.error.504.description',
    buttonLabel: 'classic.error.button.label.base44',
    buttonLink: 'classic.error.button.link.base44',
  },
  '400-Symphony': {
    title: 'classic.error.400.title',
    description: 'classic.error.400.description',
    buttonLabel: '',
    buttonLink: '',
    hideCTA: true,
  },
  '401-Symphony': {
    title: 'classic.error.401.title',
    description: 'classic.error.401.description',
    buttonLabel: 'classic.error.button.label.symphony',
    buttonLink: 'classic.error.button.link.symphony',
  },
  '403-Symphony': {
    title: 'classic.error.403.title',
    description: 'classic.error.403.description.symphony',
    buttonLabel: 'classic.error.button.label.symphony',
    buttonLink: 'classic.error.button.link.symphony',
  },
  '404-Symphony': {
    title: 'classic.error.404.title',
    description: 'classic.error.404.description.symphony',
    buttonLabel: 'classic.error.button.label.symphony',
    buttonLink: 'classic.error.button.link.symphony',
  },
  '410-Symphony': {
    title: 'classic.error.410.title',
    description: 'classic.error.410.description.symphony',
    buttonLabel: 'classic.error.button.label.symphony',
    buttonLink: 'classic.error.button.link.symphony',
  },
  '429-Symphony': {
    title: 'classic.error.429.title',
    description: 'classic.error.429.description',
    buttonLabel: 'classic.error.button.label.symphony',
    buttonLink: 'classic.error.button.link.symphony',
  },
  '500-Symphony': {
    title: 'classic.error.500.title',
    description: 'classic.error.500.description.symphony',
    buttonLabel: 'classic.error.button.label.symphony',
    buttonLink: 'classic.error.button.link.symphony',
  },
  '502-Symphony': {
    title: 'classic.error.502.title',
    description: 'classic.error.502.description.symphony',
    buttonLabel: 'classic.error.button.label.symphony',
    buttonLink: 'classic.error.button.link.symphony',
  },
  '503-Symphony': {
    title: 'classic.error.503.title',
    description: 'classic.error.503.description.symphony',
    buttonLabel: 'classic.error.button.label.symphony',
    buttonLink: 'classic.error.button.link.symphony',
  },
  '504-Symphony': {
    title: 'classic.error.504.title',
    description: 'classic.error.504.description.symphony',
    buttonLabel: 'classic.error.button.label.symphony',
    buttonLink: 'classic.error.button.link.symphony',
  },
  default: {
    title: 'classic.error-title',
    description: 'classic.error.default.description',
    buttonLabel: 'classic.error.default.button.label',
    buttonLink: 'classic.error.default.button.link',
  },
};
